"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Map = void 0;
var _jsxRuntime = require("react/jsx-runtime");
const Map = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M48.72,30.22h3.21c1.49,0,2.83,0.91,3.38,2.3l6.93,17.59c0.94,2.38-0.82,4.97-3.38,4.97H6.14\r c-2.56,0-4.32-2.58-3.38-4.97l6.93-17.59c0.55-1.39,1.89-2.3,3.38-2.3h3.18"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M32.5,9.92c-5.55,0-13.87,2.52-13.87,12.61c0,3.85,6.45,15.02,10.75,22.35c1.4,2.39,4.85,2.39,6.25,0\r c4.29-7.33,10.75-18.51,10.75-22.35C46.37,12.45,38.05,9.92,32.5,9.92z M32.5,28.8c-3.46,0-6.27-2.81-6.27-6.27\r c0-3.46,2.81-6.27,6.27-6.27c3.46,0,6.27,2.81,6.27,6.27C38.77,26,35.96,28.8,32.5,28.8z"
      })]
    })
  });
};
exports.Map = Map;